<template>
  <div class="modal fade" id="qr-code-device" tabindex="-1" aria-hidden="true">
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <div class="modal-content">
        <div class="modal-body">
          <button
            type="button"
            class="btn-close"
            id="device-qr-code-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
          <div class="row g-6 text-center">
            <div
              class="col-12 justify-items-center"
              v-if="qr && this.selectedNas.wa_status == 'ready_to_connect'"
            >
              <div class="font-bold text-xl">
                {{ $t("notifications.wa.scan_qr") }}
              </div>
              <img :src="`${qr}`" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  name: "deviceQrCode",
  computed: {
    ...mapGetters(["user", "settings"]),
  },
  props: {
    selectedNas: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      error: "",
      message: "",
      error_message: "",
      loading: false,
      inside_page: true,
      qr: null,
      debounce: null,
    };
  },
  async created() {
    this.loading = true;
    this.getQr();
    while (this.inside_page) {
      this.getQr();
      //   this.debounce = setTimeout(async () => {
      //     this.getQr();
      //   }, 30000);
      await new Promise((r) => setTimeout(r, 30000));
    }
    this.loading = false;
  },
  destroyed() {
    clearTimeout(this.debounce);
    this.inside_page = false;
  },
  methods: {
    async getQr() {
      // this.loading = true;
      var res = await axios.get(
        `wa/qr?wa_instance=${this.selectedNas.wa_instance}`,
      );
      if (res.status == 200) {
        this.qr = res.data.qr_code;
        if (this.qr == null) {
          this.selectedNas.wa_status = "connected";
          this.$notify({
            text: this.$t("messages.whatsapp_linked_successfully"),
            type: "success",
          });
          this.inside_page = false;
          document.getElementById("device-qr-code-close").click();
        }
      }
      // this.loading = false;
    },
  },
};
</script>
